import NotificationCenter from 'pages/BackOfficePage/BackOfficeCategories/NotificationCenter/NotificationCenter';

export default NotificationCenter;
